'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/secondsFromNow.js